import * as Yup from 'yup'

export const bookingSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoEmpresaId: Yup.string().required('Tipo de Empresa es requerido'),
  ClienteContratista: Yup.string().required('Cliente/Contratista es requerido'),
  TipoModuloId: Yup.string().required('Tipo de Módulo es requerido'),
  TipoHabitacionId: Yup.string().required('Tipo de Habitación es requerido'),
  NroCamas: Yup.string().required('Nro de Camas es requerido'),
  FechaInicio: Yup.string().required('Fecha Inicio es requerido'),
  FechaFin: Yup.string().required('Fecha Fin es requerido'),
})

export const bookingFaceToFaceSchema = Yup.object().shape({
  CampamentoId: Yup.string().required('Campamento es requerido'),
  HuespedId: Yup.string().required('Huesped es requerido'),
  ModuloId: Yup.string().required('Modulo es requerido'),
  HabitacionId: Yup.string().required('Habitación es requerido'),
  CamaId: Yup.string().required('Cama es requerido'),
})
